import { render, staticRenderFns } from "./OfficeForm.vue?vue&type=template&id=3a905e54&"
import script from "./OfficeForm.vue?vue&type=script&lang=js&"
export * from "./OfficeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports